import { render, staticRenderFns } from "./MaterialWizardCheck.vue?vue&type=template&id=5569a479"
import script from "./MaterialWizardCheck.vue?vue&type=script&lang=js"
export * from "./MaterialWizardCheck.vue?vue&type=script&lang=js"
import style0 from "./MaterialWizardCheck.vue?vue&type=style&index=0&id=5569a479&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports